<template>
  <div
    class="job-container"
    v-if="job.Id"
    :style="`border-left-color: ${jobStatus.color}`"
  >
    <div class="row justify-left items-center">
      <span class="green-name-text">{{ job.Worker?.Name }}</span>
      <q-icon color="accent" name="chevron_left" size="sm" />
      <span class="green-name-text">{{ job.Creator?.Name }}</span>
    </div>
    <div class="row no-wrap">
      <span v-html="getMessage" />
    </div>

    <!-- tags list -->

    <div class="row justify-between items-center" style="width: 100%;">
      <span class="text-primary">{{ getFinishedTime }}</span>
      <span class="text-grey-7">{{ getCreateTime }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { date } from "quasar";
import { Component, Prop, Vue } from "vue-facing-decorator";
import { JobStatus } from "../../../../models/etc/types";
import { JobLight } from "../../../../models/interfaces/entity-settings/querytable/querytable";

@Component({
  name: "JobCard",
})
export default class JobCard extends Vue {
  // === PROPS ===
  @Prop({ required: true }) readonly job!: JobLight;

  get jobStatus(): any {
    switch (this.job.Status) {
      case JobStatus.Standard:
        return {
          text: this.$t("job_is_record"),
          color: "black",
        };
      case JobStatus.Working:
        return {
          text: this.$t("job_in_progress"),
          color: "blue",
        };
      case JobStatus.WaitingForCheck:
        return {
          text: this.$t("job_waiting"),
          color: "yellow",
        };
      case JobStatus.Completed:
        return {
          text: this.$t("job_done"),
          color: "green",
        };
      case JobStatus.Lost:
      default:
        return {
          text: this.$t("job_expired"),
          color: "red",
        };
    }
  }

  get getCreateTime() {
    return date.formatDate(this.job.CreateTime, "HH:mm DD.MM.YYYY")
  }

  get getFinishedTime() {
    return this.job.CompletionDate ? date.formatDate(this.job.CompletionDate, "HH:mm DD.MM.YYYY") : ''
  }

  get getMessage() {
    return this.job.Message + (this.job.Additions ? this.job.Additions.map((add) => {
      return "<br/><br/>" +
          '<span style="color: green; font-weight: medium;">' +
          (add.Username ? " " + add.Username : "") +
          "</span>" +
          (add.Date
            ? ' <span style="color: green;">' +
              date.formatDate(new Date(add.Date), "HH:mm DD.MM.YYYY")
            : "") +
          "</span>" +
          '<br/><span style="font-weight: bold;">' +
          add.Title +
          "</span>" +
          (add.Message ? " " + add.Message : "")
    }) : '');
  }
}
</script>

<style lang="scss" scoped>
.job-container {
  display: flex;
  flex-direction: column;
  max-width: 420px;

  height: auto;
  clear: both;
  overflow: auto;
  margin-bottom: 4px;
  background-color: white;
  border-radius: 5px;
  border-radius: 5px;
  border: 1px solid $accent;
  border-left: 5px solid white;
  padding: 10px;

  row-gap: 8px;
}

.green-name-text {
  font-weight: 500;
  color: $primary;
}
</style>
